export default __webpack_public_path__ + "static/media/esterella3.97bfb21e.jpg";